import { Button, PageModal, Typography } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Routes } from 'src/components/common/router/constants';
import { VideoPlayer } from 'src/components/common/video';
import { PartialResourcePage } from 'src/components/resource/form/types';
import styles from './video-modal.module.css';

interface VideoModalProps {
  resource?: PartialResourcePage;
  onClose: (event: Object) => void;
}

export const VideoModal = ({ resource, onClose }: VideoModalProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const description = resource?.description || '';
  const video = resource?.items?.[0]?.video;

  const hasMoreVideos = resource?.items?.length && resource?.items?.length > 1;

  const onViewMore = () => {
    navigate(`${Routes.resources.path}/${resource?.id}`);
  };

  return (
    <PageModal
      open={true}
      onClose={onClose}
      title={
        <>
          <Typography variant="subtitle1" fontWeight="bold">
            {resource?.name}
          </Typography>
          <Typography
            variant="subtitle2"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </>
      }
      fullWidth
      maxWidth="xl"
    >
      {video && <VideoPlayer video={video} className={styles.videoWrapper} />}

      <div className="flex justify-end gap-2 mt-4">
        <Button variant="contained" onClick={onViewMore}>
          {t(
            hasMoreVideos
              ? 'resources.list.video-modal.view-more'
              : 'resources.list.video-modal.view-page',
          )}
        </Button>

        <Button variant="outlined" onClick={onClose}>
          {t('common.close')}
        </Button>
      </div>
    </PageModal>
  );
};
